import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController, IonicModule } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';
import { ReportConfig } from 'src/app/core/interfaces/report-config';
import { Location } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PBILoaderComponent } from '../pbi-loader/pbi-loader.component';
import { ResourcesEndpointEnum } from 'src/app/core/enums/resources-endpoint.enum';
import { WindowSizes } from 'src/app/core/enums/window-sizes.enum';
import { EmbedConfig } from 'src/app/core/interfaces/embed-config';
import { PowerbiService } from 'src/app/core/services/powerbi.service';
import { ResourceService } from 'src/app/core/services/resource.service';
import { ChooseSizePopoverComponent } from '../popovers/choose-size-popover/choose-size-popover.component';
import { SetRLSForTestPopoverComponent } from '../popovers/set-rls-for-test-report-popover/set-rls-for-test-report-popover.component';
import { RLSTypesEnum } from 'src/app/core/enums/rls-types.enum';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
    selector: 'app-embedding-report-testing',
    templateUrl: './embedding-report-testing.component.html',
    styleUrls: ['./embedding-report-testing.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonicModule, TranslateModule, PBILoaderComponent]
})
export class EmbeddingReportTestComponent implements OnInit, OnChanges, OnDestroy {
  report!: ReportConfig;
  embedConfig: any;
  public showLoaderContainer: boolean = true;
  public isFirstLoad: boolean = true;

  public embedding = true;
  public loading = false;
  public windowwidth = innerWidth;
  private RLSFilterText: string = '';
  private RLSConfigured: boolean = false;
  onmobileView = false;
  windowSizes = WindowSizes;
  public embeddingReport = true;
  @Input() reportId!: string;
  @Input() reportType!: string;
  @Input() groupId!: number;
  @Input() RLSInput!: string;
  isAdmin: boolean = false;
  isOwner: boolean = false;

  constructor(
    public popoverController: PopoverController,
    public pbiService: PowerbiService,
    private router: Router,
    private authService: AuthService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private toastrService: ToastrService,
    public resourceService: ResourceService)
    { }

  ngOnInit(): void {
    this.checkAccess();
    this.showLoaderContainer = false;
    if (this.windowwidth < this.windowSizes.MaxMobileWidth) {
      this.onmobileView = true;
    }
    this.getReport();
  }

  private checkAccess() {
    this.authService.isAdmin().subscribe({
      next: (recievedAdminStatus) => {
        this.isAdmin = recievedAdminStatus;
      },
      error: (err) => {
        this.isAdmin = false;
        // console.log(err);
      },
    });
    this.authService.isOwner().subscribe({
      next: (recievedOwnerStatus) => {
        this.isOwner = recievedOwnerStatus;
      },
      error: (err) => {
        this.isOwner = false;
        // console.log(err);
      },
    });
    if(!this.isAdmin && !this.isOwner) {
      this.router.navigate(['home']);
    }
  }

  private getReport() {
    if(this.isAdmin || this.isOwner) {
      this.resourceService.get<ReportConfig>(ResourcesEndpointEnum.GET_REPORT, { groupID: this.groupId, reportID: this.reportId })
        .subscribe({
          next: (report: ReportConfig) => {
            this.report = report;
            if(report.RLS ?? false) {
              var reportsGroup = report.Groups[0];
              if(this.RLSInput !== null && this.RLSInput !== '') {
                this.RLSFilterText = this.RLSInput;
                this.RLSConfigured = true;
                this.showLoaderContainer = true;
                this.loadPowerBIContent(report);
              }
              else if(report.RLSRole!.eIdType.eIdTypeID === RLSTypesEnum.FullEmail ||
                      report.RLSRole!.eIdType.eIdTypeID === RLSTypesEnum.EmailDomain ||
                      report.RLSRole!.eIdType.eIdTypeID === RLSTypesEnum.ssasEIdUsername ) {
                this.presentSetRLSPopover();
              }
              else if(report.RLSRole!.eIdType.eIdTypeID === RLSTypesEnum.GroupName && reportsGroup.Name == 'All') {
                this.presentSetRLSPopover();
              }
              else
              {
                this.RLSFilterText = reportsGroup.Name;
                this.RLSConfigured = true;
                this.showLoaderContainer = true;
                this.loadPowerBIContent(report);
              }
            }
            else{
              this.showLoaderContainer = true;
              if (this.groupId !== null && this.reportId !== '' && this.reportType !== '') {
                this.loadPowerBIContent(report);
              }
            }
            this.cdr.detectChanges();
          },
          complete: () => {
          }
        });
    }
  }

  async presentChooseSizePopover() {
    const popover = await this.popoverController.create({
      component: ChooseSizePopoverComponent,
      translucent: true
    });
    await popover.present();
    const value = (await popover.onDidDismiss()).data;
    this.pbiService.setReportSize(value);
  }

  async presentSetRLSPopover() {
    const popover = await this.popoverController.create({
      component: SetRLSForTestPopoverComponent,
      componentProps: {
        RLSType: this.report.RLSRole!.eIdType.eIdTypeID ?? RLSTypesEnum.FullEmail
      },
      translucent: true,
      backdropDismiss: !this.isFirstLoad,
      cssClass: 'RLS-popover',
    });
    await popover.present();
    const value = (await popover.onDidDismiss()).data;
    if(value.RLSPopoverInput !== null) {
      this.RLSFilterText = value.RLSPopoverInput;
      this.showLoaderContainer = true;
      if(this.isFirstLoad) {
        this.loadPowerBIContent(this.report);
      }
      else {
        window.open(`home/reports/${this.report.ReportID}/${this.report.ReportType.ReportType}?id=${this.groupId}&test=true&RLSInput=${this.RLSFilterText}`, '_self');
      }
    }
    else if(this.RLSFilterText == null || this.RLSFilterText == '') {
      this.presentSetRLSPopover();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.RLSConfigured){
      this.loadPowerBIContent(this.report);
    }
  }
  ngOnDestroy(): void { }

  loadPowerBIContent(report?: ReportConfig) {
    if(this.RLSFilterText !== null && this.RLSFilterText !== '') {
      this.resourceService.get<EmbedConfig>(ResourcesEndpointEnum.GET_REPORT_EMBEDCONFIG_FOR_TESTING,
        { groupID: this.groupId, reportID: this.reportId},
        { RLSFilterText: this.RLSFilterText}).subscribe({
        next: (data) => {
          this.embedConfig = data;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.showLoaderContainer = false;
          this.translateService.get('Error loading the report. Please close this tab and revise the settings').subscribe(t => {
            this.toastrService.error(t);
          })
        },
        complete: () => {
          this.loading = true;
          this.embedding = false;
          this.embeddingReport = this.embedConfig.EmbedType !== 'Dashboard' ? true : false;
          this.pbiService.retrieveEmbedObject(this.embedConfig, report);
        }
      });
    }
    else{
      this.resourceService.get<EmbedConfig>(ResourcesEndpointEnum.GET_REPORT_EMBEDCONFIG_FOR_TESTING,
        { groupID: this.groupId, reportID: this.reportId}).subscribe({
        next: (data) => {
          this.embedConfig = data;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.showLoaderContainer = false;
          this.translateService.get('Error loading the report. Please close this tab and revise the settings').subscribe(t => {
            this.toastrService.error(t);
          })
        },
        complete: () => {
          this.loading = true;
          this.embedding = false;
          this.embeddingReport = this.embedConfig.EmbedType !== 'Dashboard' ? true : false;
          this.pbiService.retrieveEmbedObject(this.embedConfig, report);
        }
      });
    }

    this.isFirstLoad = false;
  }

  goBack() {
    window.open(`home/admin/reports-config/${this.groupId}`, '_self');
  }
}
